import axios from 'axios';

const API_BASE =process.env.REACT_APP_BASE_API_URL;


const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,         
  withCredentials: true,      
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

// --- 401 handling: single-flight refresh + retry -----------------------------

let isRefreshing = false;
let waiters = [];

/** Queue requests while a refresh is in-flight */
function enqueueWaiter(resolve) {
  waiters.push(resolve);
}
function resolveWaiters() {
  waiters.forEach((res) => res());
  waiters = [];
}

/** Kick user to login, preserving current path+query */
function redirectToLogin() {
  try {
    const returnTo = encodeURIComponent(
      window.location.pathname + window.location.search
    );
    window.location.assign(`${API_BASE}/mvapi-ui/auth/login?returnTo=${returnTo}`);
  } catch {
  }
}


api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;

    // Network / CORS / timeout -> just bubble up
    if (!response) {
      return Promise.reject(error);
    }

    // Only handle 401 once per request
    if (response.status === 401 && !config.__isRetry) {
      config.__isRetry = true;

      try {
        if (!isRefreshing) {
          isRefreshing = true;
          // Attempt refresh using refresh cookie
          await api.post('/mvapi-ui/auth/refresh');
          isRefreshing = false;
          resolveWaiters(); // let queued requests continue
        } else {
          // Wait for the ongoing refresh to finish
          await new Promise((resolve) => enqueueWaiter(resolve));
        }

        // Retry original request
        return api(config);
      } catch (e) {
        isRefreshing = false;
        waiters = [];
        redirectToLogin();
        return Promise.reject(e);
      }
    }

    // Not a 401 (or already retried)
    return Promise.reject(error);
  }
);

export default api;
